export enum ActionViewReport {
  DOWNLOAD = "DESCARGAR",
  PREVIEW = "VISTA PREVIA",
  
}
